import { useState, type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Card,
  CardContent,
  Container,
  Divider,
  Link,
  Typography
} from '@material-ui/core';
import {
  UserSignIn
} from './UserSignIn';
import { GenerateForgotPasswordOTP } from '../ForgotPassword/ConnectionService';
import AlertMessage from 'src/components/ui-components/AlertMessage';

const Login: FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');

  const handleForgotPassword = async () => {
    if (username && username.trim() !== '') {
      try {
        const res = await GenerateForgotPasswordOTP(username);
        if (res.statusCode === 200) {
          AlertMessage({ type: 'success', msg: 'OTP sent successfully' });
          const email = res.message.match(/Email: (\S+)/)[1]; // Extract the email from the response message
          navigate('/authentication/resetPasswordbyuser', { state: { username, email } });
        } else {
          AlertMessage({ type: 'error', msg: res.message });
        }
      } catch (err) {
        Object.entries(err.errors).forEach(([, errMsg]: any) => {
          AlertMessage({ type: 'error', msg: errMsg.errorMessage });
        });
      }
    }
  };
  return (

    <>
      <Helmet>
        <title>Globatech</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh'
        }}
      >
        <Container maxWidth="xs" sx={{ py: '80px' }}>
          <Card sx={{ overflow: 'visible' }}>
            <CardContent sx={{ p: 4 }}>
              <Box>
                <Typography
                  color="textPrimary"
                  gutterBottom
                  variant="h5"
                >
                  Log in to Globatech
                </Typography>
              </Box>
              <Divider sx={{ my: 1 }} />
              <Box>
                <UserSignIn setUsername={setUsername} />
              </Box>
              <Divider sx={{ my: 2 }} />
              {/* <Typography
              color="textPrimary"
              gutterBottom
              variant="body2"
              >
              <span>Don&apos;t have an account ? </span>
              <Link
              color="textSecondary"
              component={RouterLink}
              to="/authentication/register"
              variant="body2"
              >
              Sign Up
              </Link>
            </Typography> */}
              <Typography
                color="textPrimary"
                gutterBottom
                variant="body2"
              >
                <span>Forgot password ? </span>
                <Link
                  color="textSecondary"
                  component="button"
                  onClick={handleForgotPassword}
                  variant="body2"
                >
                  Click here
                </Link>
              </Typography>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </>
  )
};

export default Login;
